import { Row } from 'react-bootstrap';
import { getAvailableSizes } from '../hooks/useWidgetSelection';
import { chunkWidgets } from '../utils/layout';
import WidgetTypeCard from './WidgetSelector/WidgetCard';
import WidgetStylesTray from './WidgetSelector/WidgetTray';

const WidgetSubCategorySection = ({
  categoryName,
  subCategory,
  cardsPerRow,
  expandedWidgetId,
  setExpandedWidgetId,
  getSelectedCountForWidget,
  isStyleSelected,
  toggleStyleSelection,
  isCompactLayout = false,
}) => {
  const expandedWidgetIndex = subCategory.widgets.findIndex(
    (widget) => String(widget.id) === String(expandedWidgetId),
  );
  const expandedWidget = expandedWidgetIndex >= 0 ? subCategory.widgets[expandedWidgetIndex] : null;
  const availableSizes = expandedWidget ? getAvailableSizes(expandedWidget) : [];
  const widgetRows = chunkWidgets(subCategory.widgets, cardsPerRow);
  const expandedWidgetRow =
    expandedWidgetIndex >= 0 ? Math.floor(expandedWidgetIndex / cardsPerRow) : -1;

  return (
    <div className="mb-4">
      <h4 className="my-1 fs-6">{subCategory.category}</h4>
      {widgetRows.map((widgetRow, rowIndex) => {
        const isExpandedRow =
          expandedWidget && availableSizes.length > 0 && expandedWidgetRow === rowIndex;

        return (
          <div
            key={`${categoryName}:${subCategory.category}:row:${String(rowIndex)}`}
            className={`position-relative ${isExpandedRow ? 'mb-4' : 'mb-3'}`}
            style={{ zIndex: isExpandedRow ? 4 : 0 }}
          >
            <Row className="g-0 gap-2">
              {widgetRow.map((widget) => (
                <WidgetTypeCard
                  key={widget.id}
                  widget={widget}
                  isExpanded={expandedWidgetId === widget.id}
                  onToggleExpanded={(widgetId) =>
                    setExpandedWidgetId((previousWidgetId) =>
                      previousWidgetId === widgetId ? null : widgetId,
                    )
                  }
                  selectedCount={getSelectedCountForWidget(widget.id)}
                />
              ))}
            </Row>

            {isExpandedRow && (
              <WidgetStylesTray
                expandedWidget={expandedWidget}
                availableSizes={availableSizes}
                isStyleSelected={isStyleSelected}
                toggleStyleSelection={toggleStyleSelection}
                isCompactLayout={isCompactLayout}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default WidgetSubCategorySection;
